import React from 'react';
import { compose } from 'lodash/fp';
import {
  connectStateResults,
  connectInfiniteHits,
} from 'react-instantsearch/connectors';
import { ContentGroup } from 'ui';
import TopicCard from '../hits/TopicHit';
import ShowMoreButton from './ShowMoreButton';

const Topics = ({ hits, searchResults }) =>
  searchResults &&
  searchResults.nbHits > 0 && (
    <div className="LearnContentGroup">
      <ContentGroup
        title={t('content.groups.topics')}
        items={hits}
        customCount={searchResults.nbHits}
      >
        <ContentGroup.Items
          render={hit => <TopicCard key={hit.objectID} hit={hit} />}
        />
      </ContentGroup>
      <ShowMoreButton />
    </div>
  );

export default compose(connectInfiniteHits, connectStateResults)(Topics);
